import { useMemo } from 'react';

import type { MessageMapping } from '@ui/uikit/components/common/SharingDropdownMenu';

interface FarmPoolShareInfo {
  url: string;
  name: string;
  amount: string | number;
  currency: string | null;
}

export const useFarmPoolShareConfig = ({
  url,
  name,
  amount,
  currency,
}: FarmPoolShareInfo): MessageMapping => {
  return useMemo(() => {
    const reward = `${amount} ${currency || ''}`;

    return {
      Reddit:
        `🌾 Stake in the ${reward} Farm Pool from ${name}, hosted by Magic Square,  \n` +
        `and claim your share of ${reward}!  \n` +
        '\n' +
        '⚡ The earlier you join, the higher your APR!  \n' +
        '\n' +
        '🔗 Join here: {{url}}',
      Email:
        `🚀 Guess what? ${name} just launched their ${reward} Farm Pool, hosted by Magic Square!  \n` +
        '\n' +
        `💎 The best part? There's a total of ${reward} in rewards waiting to be shared—stake your part today!  \n` +
        '\n' +
        '⚡ The earlier you join, the higher your APR—maximize your earnings now!  \n' +
        '\n' +
        '🔗 Stake & Claim Rewards here: {{url}}',
      X:
        `🌱 Join the ${reward} Farm Pool from ${name}, hosted by Magic Square!  \n` +
        `💰 A total of ${reward} in rewards is waiting—stake your share today.  \n` +
        '\n' +
        '⚡ The earlier you join, the higher your APR!  \n' +
        '\n' +
        '🔗 Stake & Claim Rewards: {{url}} via @MagicSquareio',
      Telegram:
        `🚀 Guess what? ${name} just launched their ${reward} Farm Pool, hosted by Magic Square!  \n` +
        '\n' +
        `💎 The best part? There's a total of ${reward} in rewards waiting to be shared—stake your part today!  \n` +
        '\n' +
        '⚡ The earlier you join, the higher your APR—maximize your earnings now!  \n' +
        '\n' +
        '🔗 Stake & Claim Rewards here: {{url}}',
      WhatsApp:
        `🚀 Guess what? ${name} just launched their ${reward} Farm Pool, hosted by Magic Square!  \n` +
        '\n' +
        `💎 The best part? There's a total of ${reward} in rewards waiting to be shared—stake your part today!  \n` +
        '\n' +
        '⚡ The earlier you join, the higher your APR—maximize your earnings now!  \n' +
        '\n' +
        '🔗 Stake & Claim Rewards here: {{url}}',
      default:
        `🚀 Guess what? ${name} just launched their ${reward} Farm Pool, hosted by Magic Square!  \n` +
        '\n' +
        `💎 The best part? There's a total of ${reward} in rewards waiting to be shared—stake your part today!  \n` +
        '\n' +
        '⚡ The earlier you join, the higher your APR—maximize your earnings now!  \n' +
        '\n' +
        '🔗 Stake & Claim Rewards here: {{url}}',
    };
  }, [amount, name, currency]);
};
